export default {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    fontFamily: "outfit",
    color: "#000",
    "@media(max-width:767px)": {
      fontSize: "20px",
    },
  },

  h2: {
    fontWeight: 500,
    fontSize: 30,
    fontFamily: "outfit",
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
    fontFamily: "outfit",
    color: "#fff",
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    fontFamily: "outfit",
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
    color: "black",
    fontFamily: "outfit",
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
    fontFamily: "outfit",
  },
  overline: {
    fontWeight: 500,
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: "outfit",
  },
  body1: {
    fontSize: 16,
    color: "black",
    fontFamily: "outfit",
  },
  body2: {
    fontSize: 14,
    fontWeight: "300",
    color: "black",
    lineHeight: "21px",
    fontFamily: "outfit",
  },
};
